import React, { Component } from "react"
import * as dateHelper from "../../booking/helpers/date"
import * as endpoints from "../../api/endpoints"
import ReactHtmlParser from "react-html-parser"
import { isMobile, isIOS } from "react-device-detect"
import da from "date-fns/locale/da"
import enGB from "date-fns/locale/en-GB"
import Svg from "../_svgs/svg"
import SearchOverlay from "./search-overlay"
import pointInPolygon from "point-in-polygon"
import reactStringReplace from "react-string-replace"
import * as endpoint from "../../booking/constants/Endpoints"
import axios from "axios"
import ipRangeCheck from "ip-range-check"
import { getIPRange } from "get-ip-range"
import OutsideClickTrigger from "../../booking/components/common/OutsideClickTrigger"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import * as cookieHelper from "../../helpers/cookie"
import { DateTime } from "luxon"

export default class FlightSearchHero extends Component {
  constructor(props) {
    super(props)

    const dtLocale = dateHelper.luxonLocale(props.locale)
    const zone = "Europe/Copenhagen"
    const cphTimeConvert = DateTime.local().setLocale(dtLocale).setZone(zone) // gets local time and changes timezone to copenhagen to get correct time
    const cphTime = cphTimeConvert.setZone("local", { keepLocalTime: true }) // locks in copenhagen time and switches back to local timezone. This ensures the time will stay CPH time when we later converts the DateTime to a JS Date object.
    let startDate = cphTime.set({ milliseconds: 0, seconds: 0, minutes: 60 }).minus({ hours: 1 })
    let minDate = startDate.minus({ days: 1 })
    let minTime = cphTime.set({ hours: 0, minutes: 0, seconds: 0, milliseconds: 0 })
    let maxTime = cphTime.set({ hours: 23, minutes: 0, seconds: 0, milliseconds: 0 })

    this.state = {
      flights: [],
      direction: "D",
      q: "",
      showOverlay: false,
      searchDate: startDate,
      minDate: minDate,
      datepickerOpen: false,
      renderWaitingTime: false,
      t2WaitingTime: "N/A",
      t3WaitingTime: "N/A",
      minTime: minTime,
      maxTime: maxTime,
      otherDaysMinTime: minTime,
      airports: [],
      airlines: [],
      startDate: startDate,
      scrollDistance: 0,
      scrollStart: 0,
    }
  }

  componentDidMount() {
    this.addEventListeners()
    if (this.props.alwaysShowWaitingTimes) {
      this.setState({ renderWaitingTime: true }, () => {
        this.getWaitingTime()
        setInterval(this.getWaitingTime, 10000)
      })
    } else if (isMobile) {
      if (this.props.ipAddress && this.props.ipRange) {
        if (ipRangeCheck(this.props.ipAddress, getIPRange(this.props.ipRange))) {
          this.setState({ renderWaitingTime: true }, () => {
            this.getWaitingTime()
            setInterval(this.getWaitingTime, 10000)
          })
        } else {
          this.getLocation()
        }
      } else {
        this.getLocation()
      }
    }
  }

  addEventListeners() {
    window.addEventListener("resize", (event) => {
      this.setState({ screenWidth: event.target.screen.width })
    })
    document.body.addEventListener("keydown", (e) => {
      let flightId = document.getElementById("flight-search-hero-input")
      let flightIsFocused = document.activeElement === flightId

      if (e.key === "Escape") {
        this.setState({ showOverlay: false })
        if (isMobile) {
          const elements = document.getElementsByClassName("site-header")
          const siteHeader = elements[0]
          if (siteHeader) {
            siteHeader.style.display = null
            const siteHeaderWrapper = document.getElementsByClassName("site-header-wrapper")[0]
            if (siteHeaderWrapper) {
              siteHeaderWrapper.style.height = siteHeader.clientHeight + "px"
            }
          }
          this.setZIndexOfNotificationBanner(null)
          document.body.classList.remove("disable-scroll")
        }
        const input = document.querySelector("#flight-search-hero-input")
        if (input) {
          input.blur()
        }
      }
      if (e.key === "Enter" && flightIsFocused) {
        window.location.href = `${this.state.direction === "D" ? this.props.departuresPage : this.props.arrivalsPage}?q=${
          this.state.q
        }&date=${this.state.searchDate.toFormat("dd / MM / yyyy")}&time=${this.state.searchDate.toFormat("HH")}`
      }
    })
  }

  search = async () => {
    if (this.state.q.length >= (this.props.minCharsBeforeSearch ?? 2)) {
      const dt = this.state.searchDate
      const zone = "Europe/Copenhagen"
      const cphTime = dt.setZone(zone, { keepLocalTime: true }) // set zone to copenhagen and keep local time, which is already cph time
      const start = cphTime.toUTC() // convert to UTC which is what Solr expects
      const end = cphTime.endOf("day").toUTC() // convert to UTC which is what Solr expects
      const flightsData = {
        direction: this.state.direction,
        query: this.state.q,
        startDateTime: start,
        endDateTime: end,
        language: this.props.locale,
      }

      // use this data and call GetAirports endpoint to get airports from solr core instead of flightinfo
      // const airportsData = { language: this.props.locale, query: this.state.q, limit: this.props.allFlightsLimit }
      const returns = await Promise.all([this.getFlights(flightsData), this.getAirports(flightsData)])
        .then((responses) => {
          return Promise.all(
            responses.map((response) => {
              return response
            }),
          )
        })
        .then((data) => {
          return data
        })
        .catch((err) => {
          console.log(err)
        })
      const flights = returns[0]
      const airports = returns[1]
      const airlines = this.getAirlines(flights)
      this.setState({ flights: flights, airports: airports, airlines: airlines })
    }
  }

  getFlights = (data) => {
    return endpoints
      .getFlightInfoTable(data)
      .then((res) => {
        return res.data
      })
      .then((data) => {
        let flights = []
        if (data) {
          flights = data
        }
        return flights
      })
      .catch((err) => {
        console.log(err)
      })
  }

  getAirports = (data) => {
    // return endpoints.getAirports(data)
    return endpoints
      .getAirportsFromFlights(data)
      .then((res) => {
        return res.data
      })
      .then((data) => {
        let airports = []
        if (data) {
          airports = data
        }
        return airports
      })
      .catch((err) => {
        console.log(err)
      })
  }

  getAirlines = (flights) => {
    let airlines = []
    if (flights && flights.length > 0) {
      const result = Array.from(new Set(flights.map((f) => f.IataAirline))).map((iata) => {
        return {
          iata: iata,
          name: flights.find((f) => f.IataAirline === iata).Airline,
          nameMobile: flights.find((f) => f.IataAirline === iata).AirlineMobile,
        }
      })
      airlines = result
    }
    return airlines
  }

  handleInput = (event, search = true) => {
    this.setState(
      {
        [event.target.name]: event.target.value,
      },
      () => {
        if (this.state.q.length >= 1) {
          if (isMobile && !this.state.showOverlay) {
            // scroll to top to fix the input field in the overlay being out of view on iphone
            window.scrollTo(0, 0)
            this.setZIndexOfNotificationBanner(0)
          }
          this.setState({ showOverlay: true }, () => {
            if (search) this.search()
            if (isMobile) {
              const elements = document.getElementsByClassName("site-header")
              const siteHeader = elements[0]
              if (siteHeader) {
                siteHeader.style.display = "none"
              }
              document.body.classList.add("disable-scroll")
            }
          })
        } else {
          if (!isMobile) {
            this.handleCloseOverlay()
          }
        }
      },
    )
  }

  handleDirectionChange = (direction) => {
    this.setState({ direction: direction }, () => {
      this.search()
    })
  }

  handleCloseOverlay = () => {
    this.setState({ showOverlay: false, searchDate: this.state.startDate, q: "", flights: [], airports: [] }, () => {
      if (isMobile) {
        const elements = document.getElementsByClassName("site-header")
        const siteHeader = elements[0]
        if (siteHeader) {
          siteHeader.style.display = null
          const siteHeaderWrapper = document.getElementsByClassName("site-header-wrapper")[0]
          if (siteHeaderWrapper) {
            siteHeaderWrapper.style.height = siteHeader.clientHeight + "px"
          }
        }
        this.setZIndexOfNotificationBanner(null)
        document.body.classList.remove("disable-scroll")
      }
    })
  }

  handleDateChange = (dateInput) => {
    this.setState(
      (prevState) => {
        let dateTime = DateTime.fromJSDate(dateInput)
        const startOfPrevDate = prevState.searchDate.startOf("day")
        const startOfMinDate = prevState.minDate.startOf("day")
        const startOfNewDate = dateTime.startOf("day")
        if (startOfMinDate.toMillis() === startOfNewDate.toMillis()) {
          // if the times are the same, meaning only the date was changed, set date to minDate
          const time = dateTime.toFormat("HH:mm")
          const prevTime = prevState.searchDate.toFormat("HH:mm")
          if (dateTime <= prevState.minDate || time === prevTime) {
            return { searchDate: prevState.minDate, minTime: prevState.minDate }
          }
          return { searchDate: dateTime, minTime: prevState.minDate }
        } else {
          // if the dates have changed, set time to 0
          if (startOfPrevDate.toMillis() !== startOfNewDate.toMillis()) {
            dateTime = dateTime.set({ hours: 0, minutes: 0, seconds: 0, milliseconds: 0 })
            if (document.getElementsByClassName("react-datepicker__time-list")[0]) {
              document.getElementsByClassName("react-datepicker__time-list")[0].scrollTo({
                top: 0,
                behavior: "smooth",
              })
            }
          }
          return { searchDate: dateTime, minTime: prevState.otherDaysMinTime }
        }
      },
      () => this.search(),
    )
  }

  handleDatepicker = () => {
    this.setState({ datepickerOpen: !this.state.datepickerOpen })
  }

  closeDatepicker = () => {
    this.setState({ datepickerOpen: false })
  }

  getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.checkLocation)
    }
  }

  checkLocation = (position) => {
    // check if coords is inside airport polygon
    if (position.coords) {
      const polygon = this.createPolygon(this.props.coordinates)
      const isAtAirport = pointInPolygon([position.coords.latitude, position.coords.longitude], polygon)
      if (isAtAirport) {
        this.setState({ renderWaitingTime: true }, () => {
          this.getWaitingTime()
        })
      }
    }
  }

  createPolygon = (coordinates) => {
    const polygon = []
    coordinates.forEach((coords) => {
      polygon.push([coords.latitude, coords.longitude])
    })
    return polygon
  }

  getWaitingTime = () => {
    const hosts = document.body && document.body.dataset.hosts && JSON.parse(document.body.dataset.hosts)
    axios.get(endpoint.WAITING_TIME_SECURITY(hosts)).then(
      (result) => {
        // let time = result.data[terminal + "WaitingTimeInterval"] + " min"
        if (result.status === 204) {
          this.setState({
            // [stateKey]: time
            t2WaitingTime: "N/A",
            t3WaitingTime: "N/A",
          })
          return
        }
        this.setState({
          // [stateKey]: time
          t2WaitingTime: result.data.t2WaitingTimeInterval,
          t3WaitingTime: result.data.t3WaitingTimeInterval,
        })
      },
      (error) => {
        this.setState({
          // [stateKey]: "N/A",
          t2WaitingTime: "N/A",
          t3WaitingTime: "N/A",
          error,
        })
      },
    )
  }

  getWaitingTimeString = (text, input) => {
    const newText = text.replace("{time}", input)
    const regex = new RegExp(/\((.*?)\)/)
    return reactStringReplace(newText, regex, (match, i) => <span key={match + i}>({match})</span>)
  }

  handleOutsideClick = () => {
    if (!this.state.overInput) {
      this.setState({ showOverlay: false, datepickerOpen: false })
    }
  }

  handleInputFocus = () => {
    if (this.state.q.length > 0) {
      if (isMobile && !this.state.showOverlay) {
        // scroll to top to fix the input field in the overlay being out of view on iphone
        window.scrollTo(0, 0)
        this.setZIndexOfNotificationBanner(0)
      }
      this.setState({ showOverlay: true }, () => {
        if (isMobile) {
          const elements = document.getElementsByClassName("site-header")
          const siteHeader = elements[0]
          if (siteHeader) {
            siteHeader.style.display = "none"
          }
          document.body.classList.add("disable-scroll")
        }
      })
    }
  }

  handleTouchStart = () => {
    if (isIOS) {
      this.setState({ scrollStart: window.pageYOffset })
    }
  }

  handleTouchEnd = (e) => {
    if (isIOS) {
      let end = window.pageYOffset
      let distance = end - this.state.scrollStart
      if (distance === 0) {
        // only if you havent scrolled
        e.target.focus()
      }
      this.setState({ scrollStart: 0 })
    }
  }

  handleMouseLeave = (e) => {
    this.setState({ overInput: false })
    if (isIOS) {
      e.target.blur() // force blur on mouse leave on iOS, which triggers when clicking outside the input field
    }
  }

  handleInputClick = (e) => {
    e.target.focus() // force focus for iOS
  }

  setZIndexOfNotificationBanner = (zindex) => {
    const notificationBanner = document.querySelector(".notification")
    if (notificationBanner) {
      const notificationVersion = notificationBanner.dataset.notificationVersion
      const notificationCookie = cookieHelper.getCookie(notificationVersion)
      if (notificationCookie !== "closed") {
        notificationBanner.style.zIndex = zindex
      }
    }
  }

  render() {
    let heroStyle = {}
    let renderHeroImage = false
    if (isMobile && this.props.backgroundImageMobile) {
      heroStyle = { backgroundImage: `url(${this.props.backgroundImageMobile})` }
      renderHeroImage = true
    } else if (this.props.backgroundImage) {
      heroStyle = { backgroundImage: `url(${this.props.backgroundImage})` }
      renderHeroImage = true
    }
    const { renderWaitingTime } = this.state
    let t2WaitingTime, t3WaitingTime
    if (renderWaitingTime) {
      t2WaitingTime = this.getWaitingTimeString(this.props.terminalTwoWaitingLabel || "Terminal 2 ({time})", this.state.t2WaitingTime)
      t3WaitingTime = this.getWaitingTimeString(this.props.terminalThreeWaitingLabel || "Terminal 3 ({time})", this.state.t3WaitingTime)
    }

    const topPadding = SelectionFactoryHelper.getFromSelectionFactory(this.props.topPadding)
    const bottomPadding = SelectionFactoryHelper.getFromSelectionFactory(this.props.bottomPadding)
    const bottomMargin = SelectionFactoryHelper.getFromSelectionFactory(this.props.bottomMargin)

    return (
      <>
        {renderHeroImage ? (
          <img
            style={{ display: "none" }}
            loading="eager"
            fetchPriority="high"
            src={isMobile ? this.props.backgroundImageMobile : this.props.backgroundImage}
          ></img>
        ) : (
          ""
        )}
        <section
          className={`deck deck--front ${topPadding ? topPadding : ""} ${bottomPadding ? bottomPadding : ""} ${bottomMargin ? bottomMargin : ""}`}
          style={heroStyle}
        >
          <header className="section-header section-header-search">
            <div className="section-header__inner">
              <div className="infohead__white">{this.props.title}</div>
              <h1>{ReactHtmlParser(this.props.heading)}</h1>
              <div className="form">
                <div className="form__section form__section--light form__section--fat">
                  <div className={`form__section__inner ${isMobile && this.state.showOverlay ? "is-active" : ""}`}>
                    <OutsideClickTrigger onOutsideClick={() => (isMobile ? undefined : this.handleOutsideClick())}>
                      <React.Fragment>
                        <div className="form__field form__field--text form__field--text-search form__field--text--no-label is-bound is-filled">
                          <span className="form__valid"></span>
                          <input
                            className="form__item"
                            id="flight-search-hero-input"
                            autoComplete="off"
                            autoCapitalize="none"
                            name="q"
                            type="text"
                            placeholder={this.props.searchBoxPlaceholder}
                            value={this.state.q}
                            onChange={(e) => this.handleInput(e)}
                            onMouseEnter={() => this.setState({ overInput: true })}
                            onMouseLeave={(e) => this.handleMouseLeave(e)}
                            onFocus={() => this.handleInputFocus()}
                            onClick={(e) => this.handleInputClick(e)}
                            onTouchStart={() => this.handleTouchStart()}
                            onTouchEnd={(e) => this.handleTouchEnd(e)}
                          />
                          {!isMobile ? (
                            <button
                              tabIndex={-1}
                              className={`search-button ${this.state.showOverlay ? "active" : ""}`}
                              onClick={this.state.showOverlay ? this.handleCloseOverlay : undefined}
                            >
                              <div className={`search-icon`}></div>
                            </button>
                          ) : (
                            ""
                          )}
                          {isMobile && this.state.showOverlay ? (
                            <button onClick={this.handleCloseOverlay}>
                              <Svg iconName={"close"} fillColor={"#071143"} />
                            </button>
                          ) : (
                            ""
                          )}
                        </div>
                        <SearchOverlay
                          {...this.props}
                          {...this.state}
                          handleDirectionChange={this.handleDirectionChange}
                          handleDateChange={this.handleDateChange}
                          locale={this.props.locale === "da" ? da : enGB}
                          handleDatepicker={this.handleDatepicker}
                          closeDatepicker={this.closeDatepicker}
                          showTime={isMobile ? false : true}
                        />
                      </React.Fragment>
                    </OutsideClickTrigger>
                  </div>
                </div>
              </div>
              {renderWaitingTime ? (
                <div className="secwait">
                  <div className="headline">{this.props.waitingTimeAtSecurity || "Ventetid i security"}</div>
                  {t2WaitingTime}&nbsp;&nbsp;&nbsp;{t3WaitingTime}
                </div>
              ) : (
                ""
              )}
            </div>
            <div className={"button-container"}>
              {this.props.arrivalsButtonLabel && this.props.arrivalsPage ? (
                <a href={this.props.arrivalsPage}>
                  <div className="button button--medium has-icon no-shadow">
                    <Svg iconName={"planetakeoff"} fillColor={"#064FC2"} />
                    <span className="text">{this.props.arrivalsButtonLabel}</span>
                  </div>
                </a>
              ) : (
                ""
              )}
              {this.props.departuresButtonLabel && this.props.departuresPage ? (
                <a href={this.props.departuresPage}>
                  <div className="button button--medium has-icon no-shadow">
                    <Svg iconName={"planetakeoff"} fillColor={"#064FC2"} />
                    <span className="text">{this.props.departuresButtonLabel}</span>
                  </div>
                </a>
              ) : (
                ""
              )}
            </div>
          </header>
        </section>
      </>
    )
  }
}
